import { GenIcon } from '../helpers/IconBase.es.js';

const HomeLocationOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 16 17", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_721_18581)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M16 7.46024V13.6442C15.9989 14.528 15.6474 15.3752 15.0225 16.0001C14.3976 16.625 13.5504 16.9765 12.6667 16.9776H12C11.8232 16.9776 11.6536 16.9073 11.5286 16.7823C11.4036 16.6573 11.3333 16.4877 11.3333 16.3109C11.3333 16.1341 11.4036 15.9645 11.5286 15.8395C11.6536 15.7145 11.8232 15.6442 12 15.6442H12.6667C13.1971 15.6442 13.7058 15.4335 14.0809 15.0585C14.456 14.6834 14.6667 14.1747 14.6667 13.6442V7.46024C14.6667 7.13286 14.5863 6.81047 14.4327 6.52139C14.279 6.2323 14.0567 5.98536 13.7853 5.80224L9.11867 2.65358C8.78892 2.42878 8.39909 2.30855 8 2.30855C7.60092 2.30855 7.21109 2.42878 6.88134 2.65358L2.21467 5.80224C1.94328 5.98536 1.721 6.2323 1.56733 6.52139C1.41367 6.81047 1.33332 7.13286 1.33334 7.46024V13.6442C1.33334 14.1747 1.54405 14.6834 1.91912 15.0585C2.2942 15.4335 2.8029 15.6442 3.33334 15.6442H4C4.17681 15.6442 4.34638 15.7145 4.47141 15.8395C4.59643 15.9645 4.66667 16.1341 4.66667 16.3109C4.66667 16.4877 4.59643 16.6573 4.47141 16.7823C4.34638 16.9073 4.17681 16.9776 4 16.9776H3.33334C2.44961 16.9765 1.60237 16.625 0.977483 16.0001C0.352591 15.3752 0.00106118 14.528 2.61138e-06 13.6442V7.46024C-0.000680639 6.91472 0.132722 6.37739 0.388472 5.89554C0.644222 5.41368 1.01448 5.00207 1.46667 4.69691L6.13334 1.54758C6.68351 1.17421 7.3331 0.974609 7.998 0.974609C8.6629 0.974609 9.3125 1.17421 9.86267 1.54758L14.5293 4.69691C14.982 5.00191 15.3528 5.41339 15.6092 5.89521C15.8656 6.37702 15.9998 6.91444 16 7.46024Z",
              fill: "black"
            }
          },
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M12.3138 12.7685C12.5484 12.2022 12.6683 11.5949 12.6666 10.9819C12.6666 10.2142 12.4773 9.45826 12.1153 8.7812C11.7532 8.10415 11.2298 7.52687 10.5913 7.10054C9.95275 6.67421 9.21891 6.412 8.45481 6.33717C7.69071 6.26233 6.91994 6.37717 6.21084 6.67151C5.50174 6.96585 4.87622 7.43059 4.38972 8.02454C3.90322 8.61849 3.57078 9.3233 3.42187 10.0765C3.27296 10.8297 3.31218 11.6079 3.53604 12.3423C3.75991 13.0767 4.16152 13.7446 4.70525 14.2866L7.04325 16.5733C7.29978 16.8216 7.64285 16.9605 7.99992 16.9605C8.35699 16.9605 8.70006 16.8216 8.95659 16.5733L11.2999 14.2813C11.7346 13.849 12.0792 13.3349 12.3138 12.7685ZM11.3333 10.9819C11.3333 10.4338 11.1981 9.89408 10.9397 9.41065C10.6813 8.92721 10.3077 8.51496 9.85194 8.2104C9.39618 7.90584 8.87235 7.71838 8.32684 7.66462C7.78132 7.61086 7.23097 7.69246 6.72453 7.9022C6.21809 8.11193 5.77118 8.44332 5.4234 8.86702C5.07562 9.29071 4.8377 9.79364 4.7307 10.3313C4.62371 10.8689 4.65095 11.4246 4.81 11.9491C4.96906 12.4737 5.25503 12.9509 5.64259 13.3386L7.97592 15.6199L10.3626 13.3333C10.6717 13.0249 10.9166 12.6583 11.0832 12.2547C11.2498 11.8511 11.3348 11.4185 11.3333 10.9819Z",
              fill: "black"
            }
          },
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M9.66286 12.0884C9.88262 11.7595 9.99992 11.3728 9.99992 10.9773C9.99992 10.4468 9.78921 9.93812 9.41413 9.56305C9.03906 9.18798 8.53035 8.97726 7.99992 8.97726C7.60436 8.97726 7.21768 9.09456 6.88878 9.31433C6.55988 9.53409 6.30354 9.84645 6.15216 10.2119C6.00078 10.5774 5.96118 10.9795 6.03835 11.3674C6.11552 11.7554 6.306 12.1118 6.58571 12.3915C6.86541 12.6712 7.22178 12.8617 7.60974 12.9388C7.9977 13.016 8.39983 12.9764 8.76529 12.825C9.13074 12.6736 9.4431 12.4173 9.66286 12.0884Z",
              fill: "black"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_721_18581" },
            child: [
              {
                tag: "rect",
                attr: {
                  width: "16",
                  height: "16",
                  fill: "white",
                  transform: "translate(0 0.977539)"
                }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};

export { HomeLocationOutlined };
